import { Table } from "react-bootstrap";
import Moment from "react-moment";
import { NavLink, useNavigate } from "react-router-dom";
import { Alert, Button } from "react-bootstrap";
import ModalConfirm from "../Modal/ModalConfirm";
import { useState } from "react";
import apiCall from "../../api/api-call";

function PostJobTable({ jobPost }) {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const handleDelete = (job) => {
    setSelectedJob(job);
    setShowModal(true);
  };

  const handleConfirmModal = () => {
    //console.log("deleting item...");
    //console.log("selectedJob to delete: ", selectedJob);

    apiCall
      .deleteJobPost({ jobid: selectedJob.jobid })
      .then((response) => {
        //console.log("deleteJobPost response: ", response);
        window.location.reload();
      })
      .catch((error) => console.log("error: ", error));

    setShowModal(false);
  };

  return (
    <div className="mb-4">
      {jobPost && jobPost.length ? (
        <>
          <div className="row mb-4">
            <div className="col-lg-2">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => navigate("/create-new")}
              >
                Add New Job Post
              </button>
            </div>
          </div>
          <div className="border-bottom pb-2 mb-0">
            <h6>Your Job Posts</h6>
          </div>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Job Title</th>
                <th>Published Date</th>
                <th>End Date</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {jobPost.map((job, key) => (
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>
                    <NavLink to={`/job-detail/${job.jobid}`}>
                      {job.title}
                    </NavLink>
                  </td>
                  <td>
                    <Moment format="D MMM YYYY" withTitle>
                      {job.publishedDate}
                    </Moment>
                  </td>
                  <td>
                    <Moment format="D MMM YYYY" withTitle>
                      {new Date(job.endDate)}
                    </Moment>
                  </td>
                  <td style={style.actionCol}>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(job)}
                    >
                      <i className="far fa-trash-alt"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-success btn-sm ms-2"
                      onClick={() => navigate(`/job-detail/${job.jobid}/edit`)}
                    >
                      <i className="far fa-edit"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <ModalConfirm
            onCloseModal={() => setShowModal(false)}
            onClickConfirm={handleConfirmModal}
            onShowModal={() => setShowModal(true)}
            showModal={showModal}
          />
        </>
      ) : (
        <Alert variant={`secondary`}>
          No post available. Create your first post{" "}
          <Button
            variant="primary"
            size="sm"
            onClick={() => navigate("/create-new")}
          >
            here
          </Button>
        </Alert>
      )}
    </div>
  );
}

const style = {
  actionCol: { width: "90px" },
};

export default PostJobTable;
